import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({ chartTimeRange = 3, chartDetails = [] }) => {
  const allLabels = Array.isArray(chartDetails?.labels)
    ? chartDetails.labels
    : [];
  const datasets = Array.isArray(chartDetails?.datasets)
    ? chartDetails.datasets
    : [];
  const total = allLabels.length;
  const colors = [
    { border: "rgba(129, 193, 129, 1)", background: "rgba(129, 193, 129,0.5)" },
    { border: "rgba(207, 207, 0, 1)", background: "rgba(207, 207, 0,0.5)" },
    { border: "rgba(242, 113, 28, 1)", background: "rgba(242, 113, 28,0.5)" },
    { border: "rgba(209, 242, 240, 1)", background: "rgba(209, 242, 240,0.5)" },
    { border: "rgba(255, 0, 0, 1)", background: "rgba(255, 0, 0,0.5)" },
  ];
  const formatVal = (val) => {
    return val
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const data = {
    labels: allLabels.slice(total - chartTimeRange, total),
    datasets:
      datasets.length > 0
        ? datasets.map((dataset, index) => ({
            label: formatVal(dataset.activity),
            data: dataset.data.slice(total - chartTimeRange, total),
            borderColor: colors[index]?.border || "rgba(112, 112, 112, 1)",
            backgroundColor:
              colors[index]?.background || "rgba(112, 112, 112,0.2)",
            tension: 0.4,
          }))
        : [
            {
              label: "No Data",
              data: Array(chartTimeRange).fill(0),
              borderColor: "rgba(200,200,200,1)",
              backgroundColor: "rgba(200,200,200,0.2)",
            },
          ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          boxWidth: 10,
          boxHeight: 10,
          color: "#333",
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: "Frequent Activities",
        font: {
          size: 16,
        },
      },
      tooltip: {
        enabled: true,
        usePointStyle: true,
        boxPadding: 6,
        callbacks: {
          title: (tooltipItems) => {
            return `Month: ${tooltipItems[0].label}`;
          },
          label: (tooltipItem) => {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue} Activities`;
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Months",
          font: {
            size: 14,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: "Activity Units",
          font: {
            size: 14,
          },
        },
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default LineChart;
